import { render, staticRenderFns } from "./RecaptchaField.vue?vue&type=template&id=2e0323ca&scoped=true&"
import script from "./RecaptchaField.vue?vue&type=script&lang=js&"
export * from "./RecaptchaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0323ca",
  null
  
)

export default component.exports